import LeadRepository from "./LeadRepository";

const repositories = {
  leads: LeadRepository,
};

export const RepositoryFactory = {
  get: (name) => repositories[name],
};
